import React from "react";
import { Outlet } from "react-router-dom";
import DashboardHeader from "./dashboard/DashboardHeader";
import DashboardFooter from "./dashboard/DashboardFooter";

export default function Dashboard() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        background: "#f9fafb",
      }}
    >
      <DashboardHeader />
      <main
        style={{
          flex: 1,
          padding: "24px",
          maxWidth: "1400px",
          margin: "0 auto",
          width: "100%",
        }}
      >
        <Outlet />
      </main>
      {false && <DashboardFooter />}{" "}
    </div>
  );
}
